import { fromJS } from "immutable";
import { sparePartActions } from "actions/sparePartActions.js";

const initialState = fromJS({
  parentProducts: {
    isLoading: false,
    data: [],
    hasErrors: false
  }
});

const sparePartReducer = (state = initialState, action) => {
  switch (action.type) {
    case sparePartActions.fetchParentProducts:
      return state
        .setIn(["parentProducts", "isLoading"], true)
        .setIn(["parentProducts", "hasErrors"], false);

    case sparePartActions.fetchParentProductsSuccess:
      return state
        .setIn(["parentProducts", "isLoading"], false)
        .setIn(["parentProducts", "data"], fromJS(action.payload.data || []))
        .setIn(["parentProducts", "hasErrors"], false);

    case sparePartActions.fetchParentProductsFailure:
      return state
        .setIn(["parentProducts", "isLoading"], false)
        .setIn(["parentProducts", "hasErrors"], true);

    default:
      return state;
  }
};

export default sparePartReducer;